<template>
    <div class="" style="max-width: 100%;">
        <v-card class="gradient-primary" flat>
            <v-card-title class="pa-3">
                <div class="header-content">
                    <div class="header-left">
                        <v-avatar size="32" color="white" class="mr-4">
                            <v-icon color="dark" size="24">mdi-format-list-checks</v-icon>
                        </v-avatar>
                        <div style="flex: 1 1 0%;">
                            <h1 class="text-h4 font-weight-bold white--text mb-1">
                                Calcular Materiales
                            </h1>
                        </div>
                    </div>
                </div>
            </v-card-title>
        </v-card>

        <v-container>
            <v-row justify="center">
                <v-col cols="12" md="4">
                    <v-card class="pa-5 rounded-xl" elevation="2">

                        <v-form ref="form">
                            <v-col class="pa-0">
                                <span class="primary--text">CANTIDAD</span>
                                <v-text-field v-model="form.Quantity" label="" type="number" clearable
                                    prepend-inner-icon="mdi-numeric" class="ma-0"></v-text-field>
                            </v-col>
                            <!-- <v-card-actions class="pa-0">
                                <v-btn class="" color="primary" large block @click="calcularResultado">
                                    <v-icon left>mdi-calculator</v-icon>
                                    Calcular
                                </v-btn>
                            </v-card-actions> -->

                            <!-- <v-col class="pa-0">
                                <v-select v-model="form.TypeMaterial" :items="items" ref="materialname"
                                    label="Seleccionar Material" prepend-inner-icon="mdi-package-variant"
                                    :slotTmp="true" outline clearable autocomplete @change="change" item-value="PtmID"
                                    item-text="TypeMaterialName" :return-object="true" dense>
                                    <template #item="{ item }">
                                        <div style="display:flex; flex-direction:column;width: 100%;max-width: 240px;">
                                            <div class="font-weight-medium">{{ item.TypeMaterialName }}</div>
                                            <p class="text--secondary text-caption ma-0"
                                                style="text-transform: uppercase;display: block;">
                                                {{ item.Parameter }}
                                            </p>
                                        </div>
                                    </template>
</v-select>
</v-col> -->
                        </v-form>
                    </v-card>
                </v-col>

                <v-col cols="12" md="8">
                    <v-card style="overflow: hidden;" outlined class="pa-0 rounded-xl">
                        <v-data-table mobile-breakpoint="0" item-key="PtmID" dense :items="items" height="auto"
                            :headers="headersMaterial" class="elevation-0" :items-per-page="-1" @click:row="() => { }"
                            :sort-by="['PtmID']" :sort-desc="[true]">

                            <template v-slot:item.Result="{ item }">
                                <v-chip small outlined class="font-semibold" label color="primary">
                                    {{ form.Quantity / item.Parameter }} UND
                                </v-chip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

import _ParamsTypeMaterialService from "@/services/Technicalassistance/ParamsTypeMaterialService.js";

export default {
    components: {},
    data: () => ({
        filter: { Search: '', },
        form: {
            Quantity: 0,
            TypeMaterial: 0,
        },
        Calculated: '',
        valid: false,
        items: [],
        headersMaterial: [
            // { text: "ID", value: "PtmID", width: 80, align: "center", sortable: false },
            { text: "Cant. Sugerida", value: "Result", sortable: false, width: 70, align: "center" },
            { text: "Descripción", value: "TypeMaterialName", sortable: false },
            { text: "Cant. Requerida", value: "Parameter", sortable: false, width: 70, align: "center" },
        ]
    }),
    methods: {
        rowClick: function (item) {
            console.log(item)
        },
        calcularResultado() {
            //  let TypeMaterial = this.form.TypeMaterial ?? 0;
            // if (!parseInt(TypeMaterial || 0) > 0) {
            //     this.$fun.alert("Seleccionar tipo de material", "warning");
            //     return;
            // }
            // let Quantity = this.form.Quantity ?? 0;
            // if (!parseInt(Quantity || 0) > 0) {
            //     this.$fun.alert("Seleccionar cantidad", "warning");
            //     return;
            // }
            // let Param = this.form.Parameter ?? 0;
            // if (!parseInt(Param || 0) > 0) {
            //     this.$fun.alert("Ingresar parámetro", "warning");
            //     return;
            // }

            if (this.cantidad && this.materialSeleccionado) {
                this.Calculated = `Has seleccionado ${this.Quantity} unidad(es) de ${this.TypeMaterial}.\n\nTotal calculado: ${this.Quantity} x ${this.TypeMaterial}`;
            }
        },
        change: function (item) {
            console.log(item)
        },
        resetForm() {
            this.form = {
                PtmID: 0,
                TypeMaterial: 0,
            };
            this.Calculated = ''
        }, loadlist() {
            const UsrCreateID = this.$fun.getUserID();
            this.form.UsrCreateID = UsrCreateID;
            _ParamsTypeMaterialService.list(this.filter, UsrCreateID).then((result) => {
                this.items = result.status == 200 ? result.data : [];
                // console.log(this.items)
            }).catch((error) => {
                if (error.response) {
                    this.$fun.alert(error.response.data.Message, "error");
                } else if (error.request) {
                    console.error('No hubo respuesta del servidor');
                    this.$fun.alert("No hubo respuesta del servidor", "error");
                } else {
                    console.error('Error al configurar la solicitud:', error.message);
                    this.$fun.alert("Error al guardar los datos: " + error.message, "error");
                }
            });
        },
    },
    created() {
        this.loadlist()
    }
};
</script>
<style scoped>
.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}

.search-field-header {
    padding: 8px;
    align-items: center !important;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 1rem;
    max-width: 250px;
}

.search-field-header>>>.v-input__slot {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

@media (max-width:768px) {
    .header-content {
        flex-direction: column;
    }

    .search-field-header {
        width: 100%;
        max-width: 80%;
    }
}
</style>